// Un listado lleva `noindex` cuando no muestra avisos, o cuando sus filtros arman una combinación
// que no se quiere indexar. Con 1 aviso o más se indexa: antes hacían falta 5 en la página (INF-2307).
export const noIndexDelListado = (data, filters): boolean =>
	Boolean(
		(data?.searchFast?.data && data?.searchFast?.data?.length == 0) ||
			(filters?.neighborhood_id && filters?.neighborhood_id?.length > 2) ||
			(filters?.property_type_id && filters?.property_type_id?.length > 2) ||
			(filters?.bedrooms && filters?.bedrooms.length > 1) ||
			(filters?.order && [4, 5].includes(filters?.order))
	);
